<template>
  <ModalActions>
    <BaseButton outline size="large" @click="cancel">
      {{ cancelText }}
    </BaseButton>
    <BaseButton :theme="ctaButtonTheme" size="large" @click="confirm">
      {{ ctaButtonText }}
    </BaseButton>
  </ModalActions>
</template>

<script setup lang="ts">
import BaseButton from '@/components/generics/base/BaseButton.vue'
import ModalActions from './ModalActions.vue'

defineProps({
  cancelText: {
    type: String,
    required: true,
  },
  ctaButtonText: {
    type: String,
    required: true,
  },
  ctaButtonTheme: {
    type: String,
    required: false,
    default: 'blue',
  },
})

const emit = defineEmits(['onCancel', 'onConfirm'])

const cancel = () => {
  emit('onCancel')
}

const confirm = () => {
  emit('onConfirm')
}
</script>
